import UserContext from '@context/User/user-context';
import classNames from 'classnames';
import React, { useContext } from 'react';
import VendorVariantContext from '@context/VendorVariant/vendor-variant-context';
import styles from './SaveProductForLater.module.scss';
import HeartIcon from '../../../../../../public/static/images/HeartIcon.svg';

interface ISaveProductForLaterProps {
  className?: string;
  handleSave?: () => void;
  saved?: boolean;
}

const SaveProductForLater = ({
  handleSave,
  className = undefined,
  saved = false
}: ISaveProductForLaterProps) => {
  const { savedVendorVariantIds } = useContext(UserContext);
  const vendorVariant = useContext(VendorVariantContext);

  return (
    <button
      className={classNames(
        styles.SaveProductForLater,
        className,
        {
          [styles.Saved]:
            (savedVendorVariantIds && savedVendorVariantIds[Number(vendorVariant.id)]) || saved
        },
      )}
      type="button"
      aria-label="Save product for later"
      onClick={handleSave}
    >
      <HeartIcon />
    </button>
  );
};

export default SaveProductForLater;
